var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3333 8.00016H6.66658C5.19383 8.00016 3.99992 9.19407 3.99992 10.6668V21.3335C3.99992 22.8063 5.19383 24.0002 6.66658 24.0002H25.3333C26.806 24.0002 27.9999 22.8063 27.9999 21.3335V10.6668C27.9999 9.19407 26.806 8.00016 25.3333 8.00016ZM6.66658 5.3335C3.72107 5.3335 1.33325 7.72131 1.33325 10.6668V21.3335C1.33325 24.279 3.72107 26.6668 6.66658 26.6668H25.3333C28.2788 26.6668 30.6666 24.279 30.6666 21.3335V10.6668C30.6666 7.72131 28.2788 5.3335 25.3333 5.3335H6.66658Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28473 18.6668L7.30345 17.9195L8.4645 16.3856L6.66675 15.835L7.04128 14.6236L8.79409 15.3079L8.72667 13.3335H9.94016L9.87274 15.3079L11.6255 14.6236L12.0001 15.835L10.2023 16.3856L11.3559 17.9195L10.3746 18.6668L9.33342 17.0464L8.28473 18.6668Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9512 18.6668L13.97 17.9195L15.131 16.3856L13.3333 15.835L13.7078 14.6236L15.4606 15.3079L15.3932 13.3335H16.6067L16.5392 15.3079L18.2921 14.6236L18.6666 15.835L16.8688 16.3856L18.0224 17.9195L17.0411 18.6668L15.9999 17.0464L14.9512 18.6668Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.618 18.6668L20.6367 17.9195L21.7978 16.3856L20 15.835L20.3745 14.6236L22.1273 15.3079L22.0599 13.3335H23.2734L23.206 15.3079L24.9588 14.6236L25.3333 15.835L23.5356 16.3856L24.6891 17.9195L23.7079 18.6668L22.6667 17.0464L21.618 18.6668Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOtp);
export default __webpack_public_path__ + "static/media/ic-otp.cc5ba2f1d9025817bb5684d90035a037.svg";
export { ForwardRef as ReactComponent };